"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var formatDataForMutation_1 = require("./formatDataForMutation");
exports.formatDataForMutation = formatDataForMutation_1.formatDataForMutation;
var formatDataAfterQuery_1 = require("./formatDataAfterQuery");
exports.formatDataAfterQuery = formatDataAfterQuery_1.formatDataAfterQuery;
var formatOptimisticResponse_1 = require("./formatOptimisticResponse");
exports.formatOptimisticResponse = formatOptimisticResponse_1.formatOptimisticResponse;
//# sourceMappingURL=index.js.map